export default __webpack_public_path__ + "src/assets/images/security/sensor_warm.png?d7aa307e";